module.exports = __webpack_public_path__ + "img/pro_seven_1.d1aea110.jpg";